/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
//   console.info('You clicked a breadcrumb.');
// }

import UserList from './UserList'
// import GPStockCountJobList from '../StockJobs/GPStockJobList.js'
import UserProfile from './UserProfile'
//import DataTable from 'react-data-table-component';

import Spinner from 'components/Spinner.js';


export default class UserContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSpinner: true,
      //gpmode: false,
      content: null,
     // showModeSwitch: true,
      id: null,
      data: []
    };
  }

  componentDidMount() {
    this.reset();
    // if (this.state.id == null)
    // {
    // }
  }

  setId = (id) => {
    this.setState({
      content: <UserProfile user_id={id} reset={this.reset} />,
      showSpinner: false,
      // gpmode: false,
      // showModeSwitch: false
    });
  }

  reset = () => {
    this.setState({ 
      content: <UserList setId={this.setId} />,
      showSpinner: false,
      // gpmode: false,
      // showModeSwitch: true
    });
  }

  // pullGP = (e) => {
  //   if (confirm("Pull " + e + " into IXIMS?"))
  //   {
  //     this.setState({
  //       showSpinner: true,
  //     });
  //     var $this = this;
  //     //alert($this.props.reference_code)
  //     fetch('/api/shared/stockCountJobs/pullgp', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //         // 'Content-Type': 'application/x-www-form-urlencoded',
  //       },
  //       body: JSON.stringify({
  //         STCKCNTID: e
  //       })
  //     })
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log(data);
  //       if (data.status.success) {
  //         alert(e + ' pulled!');
  //         $this.setId(data.data.stockCountJob.reference_code)
  //       }
  //       else {
  //         $this.setState({
  //           showSpinner: false
  //         });
  //         alert('There was an error. Please try again later.')
  //       }
  //     });
  //   }
  // }

  // goGPmode = () => {
  //   this.setState({ 
  //     content: <GPStockCountJobList pullGP={this.pullGP} />,
  //     gpmode: true,
  //     showModeSwitch: true
  //   });
  // }

  render ()
  {
    return (
      <Fragment>
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/">
            MUI
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href="/material-ui/getting-started/installation/"
          >
            Core
          </Link>
          <Typography color="text.primary">Breadcrumbs</Typography>
        </Breadcrumbs> */}
        <a href='#' onClick={this.reset}>User List</a>
        <div>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.content }
        </div>
        {/* { !this.state.showModeSwitch ? null :
        !this.state.gpmode ?
        <Button variant="contained" color="primary" onClick={this.goGPmode}>Show Available GP Stock</Button>
        :
        <Button variant="contained" color="primary" onClick={this.reset}>Show Local Stock</Button>
        } */}
      </Fragment>
    );
  }
}
